import { gql } from '@apollo/client';
import { PartnerLocationInfoPartner } from '../fragments';

export default gql`
  query partnerLocation($id: ID) {
    partnerLocation(id: $id) {
      ...PartnerLocationInfoPartner
    }
  }
  ${PartnerLocationInfoPartner}
`;
